@if (isCalendarSidepanel()) {
  <ng-container [ngTemplateOutlet]="summaryTemplate" />
} @else {
  <div class="d-flex align-items-center p-4" @fade [class.pb-4]="!mobileScreen()">
    @if (!hideDateInputs()) {
      <!-- Date Input Section Start -->
      @if (!mobileScreen()) {
        <div class="col-auto stay-date-inputs-container" id="dateInput">
          <!-- Check In Date Input START -->
          <div class="stay-date-input-container">
            @if (!isStartDateEditingStarted()) {
              <button
                class="control-focus stay-date-edit-btn"
                [class.text-uppercase]="isUpperCaseLabel()"
                (click)="$event.preventDefault(); startDateEditing('CHECK_IN')"
              >
                {{ getTranslatedDate('CHECK_IN') }}
              </button>
            } @else {
              <app-textbox
                [last]="true"
                [label]="localeObj()?.tf_1_Calendar_rateCalender_checkIn"
                [showUppercaseLabel]="isUpperCaseLabel()"
                [type]="'text'"
                [placeholder]="localeObj()?.tf_1_Calendar_rateCalender_dateFormat"
                [maxlength]="10"
                name="CHECK_IN_INPUT"
                [bindValue]="startDateInput()"
                [autoFocus]="true"
                [error]="startDateError()"
                (onKeyUp)="handleKeyUp('CHECK_IN', $event)"
                (onTabKeyDown)="handleKeyUp('CHECK_IN', $event)"
                (onBlur)="endDateEditing('CHECK_IN')"
              />
            }
          </div>
          <!-- Check In Date Input END -->

          @if (!isDayUseRoomsEnabled()) {
            <i class="fa-regular fa-hyphen stay-date-input-separator"></i>

            <!-- Check Out Date Input START -->
            <div class="stay-date-input-container">
              @if (!isEndDateEditingStarted()) {
                <button
                  class="control-focus stay-date-edit-btn"
                  [class.text-uppercase]="isUpperCaseLabel()"
                  (click)="$event.preventDefault(); startDateEditing('CHECK_OUT')"
                >
                  {{ getTranslatedDate('CHECK_OUT') }}
                </button>
              } @else {
                <app-textbox
                  [last]="true"
                  [label]="localeObj()?.tf_1_Calendar_rateCalender_checkOut"
                  [showUppercaseLabel]="isUpperCaseLabel()"
                  [type]="'text'"
                  [placeholder]="localeObj()?.tf_1_Calendar_rateCalender_dateFormat"
                  [maxlength]="10"
                  name="CHECK_OUT_INPUT"
                  [bindValue]="endDateInput()"
                  [autoFocus]="true"
                  [error]="endDateError()"
                  (onKeyUp)="handleKeyUp('CHECK_OUT', $event)"
                  (onTabKeyDown)="handleKeyUp('CHECK_OUT', $event)"
                  (onBlur)="endDateEditing('CHECK_OUT')"
                />
              }
            </div>
            <!-- Check Out Date Input END -->
          }

          @if (!isDayUseRoomsEnabled() && hasStayDates() && LOS()) {
            <div class="d-flex align-items-center gap-2 stay-los-container">
              <i class="fa-regular fa-moon icon"></i>
              <span class="stay-los">{{ LOS() }}</span>
            </div>
          }
        </div>
        <!-- Date Input Section End -->
      }
    }

    @if (!hideSummary()) {
      <!-- Summary Section Start -->
      <div
        class="col summary-section d-flex {{
          mobileScreen() ? 'flex-column' : 'justify-content-end align-items-center'
        }} gap-4"
      >
        <ng-container [ngTemplateOutlet]="summaryTemplate"></ng-container>

        @if (showSkeletonLoader()) {
          <!-- Loader START -->
          <app-skeleton-loader [isMultiProp]="isMultiProp" [mobileScreen]="mobileScreen()" [loaderData]="loaderData" />
          <!-- Loader END -->
        }

        <!-- View Available Rooms Button START -->
        @if (!isLoading() && !showSkeletonLoader()) {
          @let buttonLabel =
            !isStayDateSelectionInProgress() && isAltPropertyAvailable()
              ? localeObj()?.tf_4_Calendar_altProperties
              : localeObj()?.tf_1_Calendar_button_selectRooms;

          <div [class.select-room-button-wrap]="mobileScreen()">
            <app-button
              variant="primary"
              id="s_btn_view_rooms"
              [fullWidth]="mobileScreen()"
              [isDisabled]="
                (!rateQuoteData()?.available && !isAltPropertyAvailable()) || isStayDateSelectionInProgress()
              "
              [isLoading]="isSelectRoomInProgress()"
              attr.aria-description="click this button to {{ buttonLabel }}"
              [label]="isUpperCaseLabel() ? (buttonLabel | uppercase) : buttonLabel"
              [customClass]="'w-100'"
              (onClickEvent)="handleAction(isAltPropertyAvailable() ? 'VIEW_ALTERNATE_PROPERTIES' : 'SELECT_ROOM')"
              [ngClass]="{
                'select-room-button d-block': mobileScreen(),
                'view-room-button-lg d-inline-block': isDesktopLarge(),
              }"
            />
          </div>
        } @else {
          <app-skeleton-loader
            [isMultiProp]="isMultiProp"
            [mobileScreen]="mobileScreen()"
            [loaderData]="loaderDataButton"
          />
        }
        <!-- View Available Rooms Button END -->
      </div>
      <!-- summary section END -->
    }
  </div>
}

<ng-template #summaryTemplate>
  @if (!isLoading() && !showSkeletonLoader()) {
    @if (rateQuoteData()?.available) {
      <div class="{{ !mobileScreen() && !isCalendarSidepanel() ? 'mt-1 w-50 me-30' : 'mb-10' }}" @fade>
        <div class="d-flex {{ !mobileScreen() ? 'justify-content-end' : '' }}">
          <!-- This div with image should be displayed only to loyalty user if logged in -->
          <div>
            @if (!rateQuoteData()?.availableComplimentaryNight && !rateQuoteData()?.complimentaryNight) {
              <!-- Price Display START -->
              <div>
                <div class="d-flex align-items-baseline summary-price-container">
                  <span
                    class="summary-price-from-label"
                    [class.text-uppercase]="isUpperCaseLabel()"
                    [innerHTML]="localeObj()?.tf_2_RoomList_roomSummary_from | safeHtml"
                  ></span>

                  <!-- Original Price for ADA START -->
                  @if (
                    rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                      ?.totalPriceDisplay &&
                    rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                      ?.totalPriceDisplay !==
                      rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]?.totalPriceDisplay
                  ) {
                    <span
                      class="sr-only summary-original-price"
                      [innerHTML]="localeObj()?.tf_3_MultiRoom_checkinSummery_ADA_Original_price | safeHtml"
                    ></span>
                  }
                  <!-- Original Price for ADA END -->

                  <!-- Original Price START -->
                  @if (showAverageNightlyRate()) {
                    <!-- Original Price Per Night Price START -->
                    <div>
                      @if (
                        rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                          ?.totalPriceDisplay &&
                        rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                          ?.totalPriceDisplay !==
                          rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]?.totalPriceDisplay
                      ) {
                        <del class="summary-original-price summary-striked-price">
                          <span [innerHTML]="currSymbol() | safeHtml"></span>
                          <span
                            [innerHTML]="
                              (!!!showTaxesInDisplayPrice()
                                ? rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                    ?.totalPriceDisplay
                                : includeFeesOnly()
                                  ? rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                      ?.totalPriceAfterFee
                                  : rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                      ?.totalPriceAfterTax
                              )?.toFixed(2)
                                | customPriceFormat: displayRoundedPrices() : currCode()
                                | safeHtml
                            "
                          ></span>
                        </del>
                      }
                    </div>
                    <!-- Original Price Per Night Price END -->
                  } @else {
                    <!-- Original Price Per Stay Price START -->
                    <div>
                      @if (
                        rateQuoteData()?.best_available_discounted_stay_rate_by_currency_code[currCode()]
                          ?.totalPriceDisplay &&
                        rateQuoteData()?.best_available_discounted_stay_rate_by_currency_code[currCode()]
                          ?.totalPriceDisplay !==
                          rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]?.totalPriceDisplay
                      ) {
                        <del class="summary-original-price summary-striked-price">
                          <span [innerHTML]="currSymbol() | safeHtml"></span>
                          <span
                            [innerHTML]="
                              (!!!this.showTaxesInDisplayPrice()
                                ? rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]
                                    ?.totalPriceDisplay
                                : includeFeesOnly()
                                  ? rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]
                                      ?.totalPriceAfterFee
                                  : rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]
                                      ?.totalPriceAfterTax
                              )?.toFixed(2)
                                | customPriceFormat: displayRoundedPrices() : currCode()
                                | safeHtml
                            "
                          ></span>
                        </del>
                      }
                    </div>
                    <!-- Original Price Per Stay Price END -->
                  }
                  <!-- Original Price END -->
                </div>

                <!-- Current Price (Discounted) for ADA START -->
                @if (
                  rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                    ?.totalPriceDisplay > 0 ||
                  rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]?.totalPriceDisplay > 0
                ) {
                  <span
                    class="sr-only summary-current-price"
                    [innerHTML]="localeObj()?.tf_3_MultiRoom_checkinSummery_ADA_Current_price | safeHtml"
                  ></span>
                }
                <!-- Current Price (Discounted) for ADA END -->

                <!-- Current Price (Discounted) START -->
                @if (showAverageNightlyRate()) {
                  <!-- Current Price Per Night Price START -->
                  <div class="d-flex align-items-center">
                    @if (
                      isLoyaltyMemberSet() &&
                      !rateQuoteData()?.availableComplimentaryNight &&
                      !rateQuoteData()?.complimentaryNight &&
                      rateQuoteData()?.isLoyaltyRateplan
                    ) {
                      <div class="me-2 vip-badge">
                        <img [src]="loyaltyIconURL()" alt="VIP badge" />
                      </div>
                    }

                    <strong class="{{ !isCalendarSidepanel() && 'price-color' }} price pt-0 me-0 summary-current-price">
                      <span [innerHTML]="currSymbol() | safeHtml"></span>
                      <span
                        [innerHTML]="
                          (!!!showTaxesInDisplayPrice()
                            ? rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                                ?.totalPriceDisplay ||
                              rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                ?.totalPriceDisplay
                            : includeFeesOnly()
                              ? rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                                  ?.totalPriceAfterFee ||
                                rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                  ?.totalPriceAfterFee
                              : rateQuoteData()?.best_available_discounted_average_rate_by_currencyCode[currCode()]
                                  ?.totalPriceAfterTax ||
                                rateQuoteData()?.best_available_average_rate_by_currencyCode[currCode()]
                                  ?.totalPriceAfterTax
                          )?.toFixed(2)
                            | customPriceFormat: displayRoundedPrices() : currCode()
                            | safeHtml
                        "
                      ></span>
                    </strong>

                    <span class="primaryTextColor ps-1 summary-per-night-label">
                      <span
                        [class.text-uppercase]="isUpperCaseLabel()"
                        [innerHTML]="localeObj()?.tf_2_RoomList_rooms_perNight | safeHtml"
                      ></span>
                    </span>
                  </div>
                  <!-- Current Price Per Night Price END -->
                } @else {
                  <!-- Current Price Per Stay Price START -->
                  <div class="d-flex align-items-center">
                    @if (
                      isLoyaltyMemberSet() &&
                      !rateQuoteData()?.availableComplimentaryNight &&
                      !rateQuoteData()?.complimentaryNight &&
                      rateQuoteData()?.isLoyaltyRateplan
                    ) {
                      <div class="me-2 vip-badge">
                        <img [src]="loyaltyIconURL()" alt="VIP badge" />
                      </div>
                    }

                    <strong class="price-color price pt-0 me-0 summary-current-price">
                      <span [innerHTML]="currSymbol() | safeHtml"></span>
                      <span
                        [innerHTML]="
                          (!!!this.showTaxesInDisplayPrice()
                            ? rateQuoteData()?.best_available_discounted_stay_rate_by_currency_code[currCode()]
                                ?.totalPriceDisplay ||
                              rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]?.totalPriceDisplay
                            : includeFeesOnly()
                              ? rateQuoteData()?.best_available_discounted_stay_rate_by_currency_code[currCode()]
                                  ?.totalPriceAfterFee ||
                                rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]
                                  ?.totalPriceAfterFee
                              : rateQuoteData()?.best_available_discounted_stay_rate_by_currency_code[currCode()]
                                  ?.totalPriceAfterTax ||
                                rateQuoteData()?.best_available_stay_rate_by_currency_code[currCode()]
                                  ?.totalPriceAfterTax
                          )?.toFixed(2)
                            | customPriceFormat: displayRoundedPrices() : currCode()
                            | safeHtml
                        "
                      ></span>
                    </strong>

                    <span class="ps-1 summary-per-stay-label">
                      <span
                        [class.text-uppercase]="isUpperCaseLabel()"
                        [innerHTML]="localeObj()?.tf_2_RoomList_rooms_label_perStay | safeHtml"
                      ></span>
                    </span>
                  </div>
                  <!-- Current Price Per Stay Price END -->
                }
                <!-- Current Price (Discounted) END -->
                <!-- </div> -->

                <div
                  class="text-start small {{ !!rateQuoteData()?.tagline ? 'mb-0' : 'mb-2' }} {{
                    iPadProScreen ? 'text-start' : ''
                  }} summary-tax-label"
                  [class.text-uppercase]="isUpperCaseLabel()"
                  [innerHTML]="taxLabel() | safeHtml"
                ></div>
              </div>
              <!-- Price Display END -->
            } @else {
              <!-- Complimentary Display START -->
              <div
                class="text-start"
                [class.text-uppercase]="isUpperCaseLabel()"
                [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_ratesStartingAt + ':' | safeHtml"
              ></div>
              <div class="d-flex align-items-baseline">
                @if (isLoyaltyEnabledProperty()) {
                  <div class="mt-2 me-2 vip-badge">
                    <img [src]="complimentaryIconURL()" alt="Complimentary badge" />
                  </div>
                }
                <div class="d-flex flex-column my-1">
                  <strong
                    class="price-color price me-0 pt-0"
                    [class.text-uppercase]="isUpperCaseLabel()"
                    [innerHTML]="
                      (rateQuoteData()?.availableComplimentaryNight
                        ? localeObj()?.tf_2_RoomList_availableComplimentaryNight_text
                        : localeObj()?.tf_2_RoomList_Complimentary_text
                      ) | safeHtml
                    "
                  ></strong>

                  @if (
                    rateQuoteData()?.availableComplimentaryNight ||
                    (rateQuoteData()?.complimentaryNight &&
                      calendarSummary?.best_available_average_rate_by_currencyCode?.[currFilterValue]
                        .totalTaxTypeTaxDisplay -
                        calendarSummary?.best_available_average_rate_by_currencyCode?.[currFilterValue]
                          .packageAddOnTax >
                        0)
                  ) {
                    <div
                      id="summary-comp-taxes"
                      [class]="!!calendarSummary?.tagline ? 'mb-0' : 'mb-2'"
                      [innerHTML]="localeObj()?.tf_1_Calendar_Loyalty_Complementary_Tax_Label | safeHtml"
                    ></div>
                  }
                </div>
              </div>
              <!-- Complimentary Display END -->
            }

            @if (!!rateQuoteData()?.tagline) {
              <!-- DPR Tag Display START -->
              @let tagline = isUpperCaseLabel() ? (rateQuoteData()?.tagline | uppercase) : rateQuoteData()?.tagline;
              <app-tag
                tagId="calendar-summary-dpr-tag"
                [label]="tagline"
                [ariaLabel]="tagline"
                icon="fa-regular fa-tag"
                variant="success"
              />
              <!-- DPR Tag Display END -->
            }
          </div>
        </div>
      </div>
    }
  }
</ng-template>
